// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  cursor: pointer;
}

.lightbox__img {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 10px;
  border: 2px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/components/lightbox/lightbox.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;AAC3C","sourcesContent":[".lightbox {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.85);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  cursor: pointer;\r\n}\r\n\r\n.lightbox__img {\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  border-radius: 10px;\r\n  border: 2px solid rgba(255, 255, 255, 0.25);\r\n  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.6);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
